import React, { useCallback, useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import { useDispatch } from "react-redux";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../redux/loader/loaderActions";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AddCircleIcon from "@mui/icons-material/AddCircle";

function DeactiveTreatmentList() {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();

  const getdata = useCallback(() => {
    dispatch(setloadeActive());
    baseUrl
      .get("alltreatment/findAllTreatment")
      .then((response) => {
        dispatch(setloadeDeactive());
        setData(response.data.data);
      })
      .catch((error) => {
        dispatch(setloadeDeactive());
        console.log(error);
      });
  }, [dispatch]);

  useEffect(() => {
    getdata();
  }, [getdata]);

  const activateTreatment = (e: any) => {
    baseUrl
      .post("alltreatment/updateTreatmentStatus", e, { headers: { status: true } })
      .then((response) => getdata())
      .catch((error) => console.log(error));
  };

  // Flatten deactivated data
  const flattenedData: any[] = [];

  // Main treatments with status1 = false
  data
    ?.filter((item: any) => item.status1 === false)
    ?.forEach((item: any) => {
      flattenedData.push({
        treatment: item?.treatment,
        type: "",
        subType: "",
        price: item?.price,
        activateData: { type: "main", mainId: item?._id },
      });
    });

  // Types with status2 = false
  data
    ?.filter((item: any) => item.status1 === true)
    ?.forEach((item: any) => {
      item?.type
        ?.filter((t: any) => t.status2 === false)
        ?.forEach((typeItem: any) => {
          flattenedData.push({
            treatment: item?.treatment,
            type: typeItem?.treatment,
            subType: "",
            price: typeItem?.price,
            activateData: { type: "sub", mainId: item?._id, subId: typeItem?._id },
          });
        });
    });

  // SubTypes with status3 = false
  data
    ?.filter((item: any) => item.status1 === true)
    ?.forEach((item: any) => {
      item?.type
        ?.filter((t: any) => t.status2 === true)
        ?.forEach((typeItem: any) => {
          typeItem?.subType
            ?.filter((s: any) => s.status3 === false)
            ?.forEach((subtype: any) => {
              flattenedData.push({
                treatment: item?.treatment,
                type: typeItem?.treatment,
                subType: subtype?.treatment,
                price: subtype?.price,
                activateData: {
                  type: "subsub",
                  mainId: item?._id,
                  subId: typeItem?._id,
                  subsubId: subtype?._id,
                },
              });
            });
        });
    });

  return (
    <>
      {/* Header Card */}
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-4 mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center">
            <MedicalServicesIcon className="text-white" sx={{ fontSize: 20 }} />
          </div>
          <div>
            <h3 className="text-lg font-bold text-slate-800 dark:text-slate-200">Deactivated Treatments</h3>
            <p className="text-sm text-slate-500 dark:text-slate-400">{flattenedData.length} treatments</p>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
        {/* Mobile Cards */}
        <div className="md:hidden p-4 space-y-3">
          {flattenedData.length === 0 ? (
            <div className="text-center py-12 text-slate-400 dark:text-slate-500">
              <MedicalServicesIcon sx={{ fontSize: 48 }} className="mb-2" />
              <p>No deactivated treatments</p>
            </div>
          ) : (
            flattenedData.map((item: any, i: number) => (
              <div key={i} className="bg-amber-50 dark:bg-amber-900/20 rounded-xl p-4 border border-amber-100 dark:border-amber-800/40">
                <div className="mb-3">
                  <p className="font-semibold text-slate-800 dark:text-slate-200">{item.treatment}</p>
                  {item.type && <p className="text-sm text-amber-600 dark:text-amber-400">{item.type}</p>}
                  {item.subType && <p className="text-xs text-slate-500 dark:text-slate-400">{item.subType}</p>}
                </div>
                <div className="flex items-center justify-between">
                  <div className="bg-white dark:bg-slate-700/50 rounded-lg px-3 py-1.5">
                    <p className="text-xs text-slate-500 dark:text-slate-400">Price</p>
                    <p className="font-semibold text-emerald-600 dark:text-emerald-400">{item.price}</p>
                  </div>
                  <button
                    onClick={() => activateTreatment(item.activateData)}
                    className="flex items-center gap-1 px-4 py-2 bg-emerald-500 dark:bg-emerald-600 text-white rounded-lg hover:bg-emerald-600 dark:hover:bg-emerald-500 transition-colors text-sm font-medium"
                  >
                    <AddCircleIcon sx={{ fontSize: 18 }} />
                    Activate
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-slate-50/80 dark:bg-slate-700/50">
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Treatment
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Sub Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Price
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-600">
              {flattenedData.length === 0 ? (
                <tr>
                  <td colSpan={5} className="px-6 py-12 text-center text-slate-400 dark:text-slate-500">
                    <MedicalServicesIcon sx={{ fontSize: 48 }} className="mb-2" />
                    <p>No deactivated treatments</p>
                  </td>
                </tr>
              ) : (
                flattenedData.map((item: any, i: number) => (
                  <tr key={i} className="hover:bg-amber-50/50 dark:hover:bg-slate-700/50 transition-colors">
                    <td className="px-6 py-3">
                      <span className="font-medium text-slate-800 dark:text-slate-200">{item.treatment}</span>
                    </td>
                    <td className="px-6 py-3">
                      {item.type ? (
                        <span className="px-2.5 py-1 bg-amber-50 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 rounded-full text-xs font-medium">
                          {item.type}
                        </span>
                      ) : (
                        <span className="text-slate-400 dark:text-slate-500">-</span>
                      )}
                    </td>
                    <td className="px-6 py-3">
                      {item.subType ? (
                        <span className="px-2.5 py-1 bg-orange-50 dark:bg-orange-900/40 text-orange-600 dark:text-orange-400 rounded-full text-xs font-medium">
                          {item.subType}
                        </span>
                      ) : (
                        <span className="text-slate-400 dark:text-slate-500">-</span>
                      )}
                    </td>
                    <td className="px-6 py-3">
                      <span className="font-semibold text-emerald-600 dark:text-emerald-400">{item.price}</span>
                    </td>
                    <td className="px-6 py-3">
                      <button
                        onClick={() => activateTreatment(item.activateData)}
                        className="flex items-center gap-1 px-3 py-1.5 bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400 rounded-lg hover:bg-emerald-100 dark:hover:bg-emerald-800/50 transition-colors text-sm font-medium"
                      >
                        <AddCircleIcon sx={{ fontSize: 16 }} />
                        Activate
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default DeactiveTreatmentList;
